/**
 * Parses a ReadableStream of SSE events and calls the onEvent callback for each 'data' line.
 */
export async function parseSSE<T>(
  stream: ReadableStream<Uint8Array>,
  onEvent: (event: T) => void
): Promise<void> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        const trimmedLine = line.trim();
        if (trimmedLine.startsWith("data: ")) {
          try {
            const jsonStr = trimmedLine.substring(6);
            const event = JSON.parse(jsonStr) as T;
            onEvent(event);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to parse SSE line:", line, e);
          }
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
}

